import axiosMapInstance from "../interceptor/webMapInstance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/anonymize`;

export const getAnonymizedOperatorsByCountry = async (countryCode) => {
  const response = await axiosMapInstance.get(`${baseUrl}/${countryCode}`,{ clearCacheEntry: true });
  return response.data.data;
};